// extracted by mini-css-extract-plugin
export var input = "index-module--input--F5Tyh";
export var textarea = "index-module--textarea--+W-w0";